import React from "react";
import "gantt-task-react/dist/index.css";
import { ViewMode } from "gantt-task-react";

const ViewSwitcher = ({
  onViewModeChange,
  onViewListChange,
  isChecked,
  viewMode,
}) => {
  return (
    <div className="ViewContainer">
      {/* <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Hour)}
        style={{ backgroundColor: `${viewMode === ViewMode.Hour ? "lightblue" : ""}` }}
      >
        Hour
      </button>
      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.QuarterDay)}
        style={{ backgroundColor: `${viewMode === ViewMode.QuarterDay ? "lightblue" : ""}` }}
      >
        Quarter of Day
      </button>
      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.HalfDay)}
        style={{ backgroundColor: `${viewMode === ViewMode.HalfDay ? "lightblue" : ""}` }}
      >
        Half of Day
      </button> */}
      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Day)}
        style={{
          backgroundColor: `${viewMode === ViewMode.Day ? "lightblue" : ""}`,
        }}
      >
        Day
      </button>
      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Week)}
        style={{
          backgroundColor: `${viewMode === ViewMode.Week ? "lightblue" : ""}`,
        }}
      >
        Week
      </button>
      <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Month)}
        style={{
          backgroundColor: `${viewMode === ViewMode.Month ? "lightblue" : ""}`,
        }}
      >
        Month
      </button>
      {/* <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.Year)}
        style={{ backgroundColor: `${viewMode === ViewMode.Year ? "lightblue" : ""}` }}
      >
        Year
      </button> */}
      {/* <button
        className="Button"
        onClick={() => onViewModeChange(ViewMode.QuarterYear)}
      >
        Year
      </button> */}
      <div className="Switch">
        <label className="Switch_Toggle">
          <input
            type="checkbox"
            defaultChecked={isChecked}
            onClick={() => onViewListChange(!isChecked)}
          />
          <span className="Slider" />
        </label>
        Show Task List
      </div>
    </div>
  );
};

export default ViewSwitcher;
